import router from '@/router';
import { computed, reactive, readonly } from 'vue';

const layoutConfig = reactive<{
  preset: 'Aura' | 'Lara';
  primary: string;
  surface: string;
  darkTheme: boolean;
  menuMode: string;
}>({
  preset: 'Aura',
  primary: 'emerald',
  surface: '',
  darkTheme: false,
  menuMode: 'static',
});

const layoutState = reactive({
  staticMenuDesktopInactive: false,
  overlayMenuActive: false,
  profileSidebarVisible: false,
  configSidebarVisible: false,
  staticMenuMobileActive: false,
  menuHoverActive: false,
  activeMenuItem: '',
});

export function useLayout() {
  const setPrimary = (value: string) => {
    layoutConfig.primary = value;
  };

  const setSurface = (value: string) => {
    layoutConfig.surface = value;
  };

  const setPreset = (value: 'Aura' | 'Lara') => {
    layoutConfig.preset = value;
  };

  const setActiveMenuItem = (item: string) => {
    layoutState.activeMenuItem = item;
  };

  const setMenuMode = (mode: string) => {
    layoutConfig.menuMode = mode;
  };

  const executeDarkModeToggle = async (): Promise<void> => {
    layoutConfig.darkTheme = !layoutConfig.darkTheme;
    document.documentElement.classList.toggle('app-dark');
  };

  const toggleDarkMode = () => {
    if (!document.startViewTransition) {
      executeDarkModeToggle();

      return;
    }

    document?.startViewTransition(() => executeDarkModeToggle());
  };

  const onMenuToggle = () => {
    if (layoutConfig.menuMode === 'overlay') {
      layoutState.overlayMenuActive = !layoutState.overlayMenuActive;
    }

    if (window.innerWidth > 991) {
      layoutState.staticMenuDesktopInactive = !layoutState.staticMenuDesktopInactive;
    }
    else {
      layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive;
    }
  };

  const resetMenu = () => {
    layoutState.overlayMenuActive = false;
    layoutState.staticMenuMobileActive = false;
    layoutState.menuHoverActive = false;
  };

  const isSidebarActive = computed(() => layoutState.overlayMenuActive || layoutState.staticMenuMobileActive);

  const isDarkTheme = computed(() => layoutConfig.darkTheme);

  const getPrimary = computed(() => layoutConfig.primary);

  const getSurface = computed(() => layoutConfig.surface);

  const cleanData = (data:any) =>  data !== '' ? data : '-';

  const edit = (data:any) =>  router.push({ name: data.name, params: {...data.params} });

  return { layoutConfig: readonly(layoutConfig), layoutState: readonly(layoutState), onMenuToggle, isSidebarActive, isDarkTheme, getPrimary, getSurface, setActiveMenuItem, toggleDarkMode, setPrimary, setSurface, setPreset, resetMenu, setMenuMode,cleanData,edit };
}
